import React from "react";

import type { AgeRange } from "@/core/types";
import { ModalControlled2 } from "@/components/UI2/molecules/Modal";

import { AcceptedAgeRangeForm } from "./AcceptedAgeRangeForm";

type AcceptedAgeRangeModalProps = {
  acceptedAgeRanges: AgeRange[];
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  setAcceptedAgeRanges: (ranges: AgeRange[]) => void;
};

export function AcceptedAgeRangeModal({
  acceptedAgeRanges,
  isOpen,
  onOpenChange,
  setAcceptedAgeRanges,
}: AcceptedAgeRangeModalProps) {
  return (
    <ModalControlled2 isOpen={isOpen} onOpenChange={onOpenChange} title="Accepted Age Range">
      <p className="tw:text-sm tw:text-text-secondary">
        Please enter the lowest and highest age of patients you will see. Both fields must be
        completed. If you are seeing all adult patients, please set maximum age as 200.
      </p>

      <AcceptedAgeRangeForm
        acceptedAgeRanges={acceptedAgeRanges}
        isOpen={isOpen}
        onCancel={() => onOpenChange(false)}
        onSubmit={(ranges) => {
          setAcceptedAgeRanges(ranges);
          onOpenChange(false);
        }}
      />
    </ModalControlled2>
  );
}
